export function getFiltersFromUrl() {
  const params = new URLSearchParams(window.location.search);
  const device = params.get("device") || "";
  const start = params.get("start") || null;
  const end = params.get("end") || null;
  return { device, start, end };
}

export function setFiltersToUrl({ device, start, end }) {
  const params = new URLSearchParams(window.location.search);
  if (device) params.set("device", device);
  else params.delete("device");
  if (start) params.set("start", start);
  else params.delete("start");
  if (end) params.set("end", end);
  else params.delete("end");
  const newUrl = `${window.location.pathname}?${params.toString()}`;
  window.history.replaceState(null, "", newUrl);
}
